import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Turtle, Compass, Bird, Waves, Flower2, CircleDot, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const CLUES = [
  "YOU FOUND A CLUE.",
  "THE ROCK REMEMBERS GREAT EXPLORERS.",
  "MORE WILL BE REVEALED SOON.",
];

const SYMBOLS = [
  { key: "turtle", Icon: Turtle, className: "top-[22%] left-[6%]" },
  { key: "compass", Icon: Compass, className: "top-[64%] right-[8%]" },
  { key: "longtail", Icon: Bird, className: "top-[40%] left-[3%]" },
  { key: "wave", Icon: Waves, className: "bottom-[10%] left-[45%]" },
  { key: "hibiscus", Icon: Flower2, className: "top-[14%] right-[14%]" },
  { key: "moongate", Icon: CircleDot, className: "bottom-[22%] right-[38%]" },
];

export function MysterySymbols() {
  const [found, setFound] = useState([]);
  const [active, setActive] = useState(null);

  const tap = async (key) => {
    setFound((f) => (f.includes(key) ? f : [...f, key]));
    let msg = CLUES[Math.floor(Math.random() * CLUES.length)];
    let awarded = [];
    try {
      const { data } = await api.post("/clues/found", { clue_key: key });
      if (data.complete && data.awarded?.length) { awarded = data.awarded; msg = "BADGE UNLOCKED: BERMUDA EXPLORER"; }
    } catch (e) { console.error("Clue submit failed:", e); }
    setActive({ key, msg, awarded });
  };

  return (
    <>
      <div className="pointer-events-none fixed inset-0 z-30">
        {SYMBOLS.map(({ key, Icon, className }) => (
          <button
            key={key}
            onClick={() => tap(key)}
            data-testid={`mystery-symbol-${key}`}
            aria-label={`Hidden ${key} clue`}
            className={`pointer-events-auto absolute ${className} text-turquoise/25 hover:text-gold hover:scale-125 transition-all duration-300 hover:drop-shadow-[0_0_10px_rgba(255,183,3,0.9)]`}
          >
            <Icon className="w-6 h-6 animate-pulse-glow" />
          </button>
        ))}
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-abyss/80 backdrop-blur-sm p-4"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            data-testid="mystery-clue-modal"
          >
            <motion.div
              initial={{ scale: 0.7, rotate: -6 }} animate={{ scale: 1, rotate: 0 }} exit={{ scale: 0.7 }}
              className="relative bg-gradient-to-br from-navy to-ocean border-2 border-gold rounded-3xl p-8 max-w-sm text-center shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <Sparkles className="w-10 h-10 text-gold mx-auto mb-3 animate-pulse" />
              <p className="font-display font-extrabold text-2xl text-gold mb-2">{active.msg}</p>
              <p className="text-white/70 text-sm">Clues discovered: {found.length} / {SYMBOLS.length}</p>
              {active.awarded?.length > 0 && (
                <p className="text-turquoise text-sm mt-2 font-semibold" data-testid="clue-badge-awarded">🏅 Awarded to {active.awarded.join(", ")}! See it in My Explorers.</p>
              )}
              <p className="text-turquoise/70 text-xs mt-3">These clues will one day connect to your explorer's Adventure Badges.</p>
              <button onClick={() => setActive(null)} className="mt-5 text-white/50 hover:text-white text-sm" data-testid="mystery-close-btn">Keep exploring →</button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
